import {lazy, Suspense, useEffect, useState} from 'react'

import PropTypes from 'prop-types'

import {useSellerType} from '@adv-mt/mt-hook-use-seller-type'

import ActionsAdReportButton from './actions-ad-report-buttons.js'

const LazyModalAdComplaint = lazy(() =>
  import(/* webpackChunkName: "ModalAdComplaint" */ '@adv-mt/mt-modal-ad-complaint')
)

const TYPES = {
  ACTION_BUTTON: 'actionButton',
  INLINE_BUTTON: 'inlineButton',
  ICON_BUTTON: 'iconButton'
}

const ActionsAdReport = ({
  adId,
  contractId,
  onClick = () => {},
  type = TYPES.ACTION_BUTTON,
  onShowModal = () => {}
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const {isDealer} = useSellerType(contractId)

  const handleOnClick = () => {
    setIsOpen(true)
    onClick()
  }

  const _onCloseModal = () => {
    setIsOpen(false)
  }

  useEffect(() => {
    isOpen && onShowModal()
  }, [isOpen]) // eslint-disable-line

  return (
    <>
      <ActionsAdReportButton onClick={handleOnClick} type={type} />
      {isOpen && (
        <Suspense fallback={<></>}>
          <LazyModalAdComplaint adId={adId} showModal={isOpen} onCloseModal={_onCloseModal} isProfessional={isDealer} />
        </Suspense>
      )}
    </>
  )
}

ActionsAdReport.displayName = 'ActionsAdReport'

ActionsAdReport.propTypes = {
  adId: PropTypes.number.isRequired,
  contractId: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(TYPES),
  onShowModal: PropTypes.func
}

export default ActionsAdReport
export {TYPES as actionsAdReportTypes}
